//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { FacebookSummaryMetricsAction } from '@facebook/actions/facebookSummaryMetricsActions';
import { FACEBOOK_SUMMARY_ACTIONS } from '@facebook/constants/facebookConstants';
import { FacebookSummaryChartOptions } from '@facebook/constants/facebookSummaryConstants';
import { IFacebookSummaryMetrics } from '@facebook/models/facebookStateModel';

const initialState: IFacebookSummaryMetrics = {
  recentPosts: [],
  summaryStats: {
    bubbleStats: undefined,
    comparisonBubbleStats: undefined,
    graphStats: [],
  },
  summaryChartSeriesOption: FacebookSummaryChartOptions.CHANGE_IN_FANS,
  errors: {
    fetchRecentPostsError: undefined,
    fetchSummaryStatsError: undefined,
  },
  flags: {
    isFetchingRecentPosts: false,
    isFetchingSummaryStats: false,
  },
};

export default function FacebookSummaryMetricsReducer(
  state: IFacebookSummaryMetrics = initialState,
  action: FacebookSummaryMetricsAction,
): IFacebookSummaryMetrics {
  switch (action.type) {
    case FACEBOOK_SUMMARY_ACTIONS.GET_RECENT_POSTS: {
      return {
        ...state,
        errors: {
          ...state.errors,
          fetchRecentPostsError: undefined,
        },
        flags: {
          ...state.flags,
          isFetchingRecentPosts: true,
        },
      };
    }
    case FACEBOOK_SUMMARY_ACTIONS.RECEIVE_RECENT_POSTS_SUCCEEDED: {
      return {
        ...state,
        recentPosts: action.recentPosts,
        flags: {
          ...state.flags,
          isFetchingRecentPosts: false,
        },
      };
    }
    case FACEBOOK_SUMMARY_ACTIONS.RECEIVE_RECENT_POSTS_FAILED: {
      return {
        ...state,
        errors: {
          ...state.errors,
          fetchRecentPostsError: action.error,
        },
        flags: {
          ...state.flags,
          isFetchingRecentPosts: false,
        },
      };
    }
    case FACEBOOK_SUMMARY_ACTIONS.GET_SUMMARY_STATS: {
      return {
        ...state,
        errors: {
          ...state.errors,
          fetchSummaryStatsError: undefined,
        },
        flags: {
          ...state.flags,
          isFetchingSummaryStats: true,
        },
      };
    }
    case FACEBOOK_SUMMARY_ACTIONS.RECEIVE_SUMMARY_STATS_SUCCEEDED: {
      return {
        ...state,
        summaryStats: action.summaryStats,
        flags: {
          ...state.flags,
          isFetchingSummaryStats: false,
        },
      };
    }
    case FACEBOOK_SUMMARY_ACTIONS.RECEIVE_SUMMARY_STATS_FAILED: {
      return {
        ...state,
        errors: {
          ...state.errors,
          fetchSummaryStatsError: action.error,
        },
        flags: {
          ...state.flags,
          isFetchingSummaryStats: false,
        },
      };
    }
    case FACEBOOK_SUMMARY_ACTIONS.UPDATE_SUMMARY_CHART_SERIES_OPTION: {
      return {
        ...state,
        summaryChartSeriesOption: action.summaryChartSeriesOption,
      };
    }
    default:
      return state;
  }
}
